import { TaxCertificatePeriod } from '@tax-certificates/interfaces/tax-certificate-period';
import { Contact } from '@contacts/interfaces/contact';

export interface TaxCertificate {
  id: number;
  code: string;
  center_id: number;
  beneficiary_firstname: string;
  beneficiary_lastname: string;
  beneficiary_fullname?: string;
  beneficiary_national_number: string;
  beneficiary_birthdate: string;
  beneficiary_street: string;
  beneficiary_street2: string;
  beneficiary_zip: string;
  beneficiary_city: string;
  beneficiary_country: string;
  beneficiary_address?: string;
  contact_id: number;
  contact_fullname?: string;
  contact?: Contact;
  tax_certificate_periods?: TaxCertificatePeriod[];
  checked?: boolean;
}

export const taxCertificatePermissionName: string = 'tax_certificates';
